import { setCustomerData, setCustomerPreferences } from '@/store/actions';
import {
  CustomerDataSlice,
  CustomerPreferencesPayload,
} from '@/store/slices/customerData/types';

/** API payload may include preferences even though they live in a separate store slice. */
type CustomerFeaturesApiPayload = CustomerDataSlice['customerData'] & {
  preferences?: CustomerPreferencesPayload;
};

const handleCustomerFeatures = (data: CustomerFeaturesApiPayload) => {
  const { features, preferences, segment } = data ?? {};

  if (features && features.length > 0) {
    setCustomerData({ features });
  }

  if (preferences && Object.keys(preferences).length > 0) {
    setCustomerPreferences(preferences);
  }

  if (segment) {
    setCustomerData({ segment });
  }
};

export default handleCustomerFeatures;
